import { Navigate, Outlet } from 'react-router-dom';

interface ProtectedRouteProps {
    children?: React.ReactNode;
}
const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const token = localStorage.getItem('OneDeskToken');

    if (!token) {
        return <Navigate to="/desklogin" replace />;
    }

    return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;
